
import type { Client } from "@/types";

export const getNewClientsCountWithComparison = (clients: Client[], days: number) => {
  const now = new Date();
  const cutoffDate = new Date(now.getTime() - (days * 24 * 60 * 60 * 1000));
  const previousCutoffDate = new Date(cutoffDate.getTime() - (days * 24 * 60 * 60 * 1000));
  
  const currentPeriodCount = clients.filter(client => 
    new Date(client.joinDate) >= cutoffDate
  ).length;
  
  const previousPeriodCount = clients.filter(client => 
    new Date(client.joinDate) >= previousCutoffDate && 
    new Date(client.joinDate) < cutoffDate
  ).length;
  
  return { currentCount: currentPeriodCount, previousCount: previousPeriodCount };
};
